import { SharingData } from '../../schema/SharingData';

export function didGetSharingInfoFail(sharingData: SharingData): boolean {
    return sharingData.sharingInfo && !sharingData.sharingInfo.getSharingInfoSucceeded;
}
